module.exports = __webpack_public_path__ + "img/img-gallery-1.47a1333f.jpg";